import { Component, HostListener, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { OnboardingService } from 'src/app/features/onboarding/onboarding.service';
import { MyAccountService } from 'src/app/core/services/my-account/my-account.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';
import { ZendeskService } from 'src/app/shared/service/zendesk.service';
 
 
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
 
 
  isLoginButtonDisabled = false;
  showMobileDropDown: boolean = false;
  showDropdownListAbout: boolean = false;
  showDropdownListDiscover: boolean = false;
  showDropdownListEngage: boolean = false;
  showDropdownListCreate: boolean = false;
  showUserDropdownList: boolean = false;
  isUserLogin: boolean = false;
  routerlink: boolean = false
  userInfo: any;
  id: any;
  name: String = "";
  img: any;
  setProfilePic: boolean = true
  urlParam: string;
  UpdatedParam: string;
  constructor(private service: UserDetailsService,
    private router: Router,
    private onboardingService: OnboardingService,
    private accountService: MyAccountService,
    private auth: AuthenticationService,
    private mixPanelService:MixpanelService,
    private zenDeskService:ZendeskService

  ) {
      this.onboardingService.profilePic$.subscribe((res)=>{
        if(res){
          this.userDetails()
          this.onboardingService.profilePic$.next(false)
        }
      })
 
      router.events.subscribe(
        (event) => {
            if (event instanceof NavigationStart){
              
            }
                // start loading pages
            if (event instanceof NavigationEnd) {
                this.auth.checkUserAuthenticated().subscribe((data:any)=>{
                  this.userInfo = data.userId;
                  if (this.userInfo > 0)  //if(this.userInfo >= 0) to display profilepicture and username
                  {
                    this.isUserLogin = true;
                    this.id = this.userInfo;
                    this.userDetails();
                  }
                  else {
                    this.isUserLogin = false;
                  }
                })
            }
        });
    }
 
  ngOnInit(): void {
    this.urlParam = this.router.url;
    this.UpdatedParam = this.urlParam.slice(0);
  
  }
 
  ngAfterViewInit(): void {
    this.accountService.parentInitEvent.subscribe(() => {
      this.userDetails();
    })
  }
 
  userDetails() {
    this.service.getUserDetails(this.id).subscribe((res: any) => {
      this.name = res.firstName
      this.img = res.profilePic
      this.onboardingService.userProfileDetails=res;
      this.onboardingService.userProfileDetails['id']=this.id;
      if (this.img == null) {
        this.setProfilePic = true
      }
      else {
        this.setProfilePic = false
      }
    })
 
 
  }
  showDropdownAbout() {
    this.showDropdownListAbout = !this.showDropdownListAbout;
    this.showDropdownListDiscover = false;
    this.showDropdownListEngage = false;
    this.showDropdownListCreate = false;
    this.showUserDropdownList = false;
 
  }
 
  showDropdownDiscover() {
    this.showDropdownListDiscover = !this.showDropdownListDiscover;
    this.showDropdownListAbout = false;
    this.showDropdownListEngage = false;
    this.showDropdownListCreate = false;
    this.showUserDropdownList = false;
  }
  showDropdownEngage() {
    this.showDropdownListEngage = !this.showDropdownListEngage;
    this.showDropdownListAbout = false;
    this.showDropdownListDiscover = false;
    this.showDropdownListCreate = false;
    this.showUserDropdownList = false;
 
  }
  showDropdownCreate() {
    this.showDropdownListCreate = !this.showDropdownListCreate;
    this.showDropdownListAbout = false;
    this.showDropdownListDiscover = false;
    this.showDropdownListEngage = false;
    this.showUserDropdownList = false;
  }
  showUserDropdown() {
    this.showUserDropdownList = !this.showUserDropdownList;
    this.showDropdownListDiscover = false;
    this.showDropdownListAbout = false;
    this.showDropdownListEngage = false;
    this.showDropdownListCreate = false;
    this.showMobileDropDown = false;
 
  }
  showDropDown() {
    this.showMobileDropDown = !this.showMobileDropDown;
    this.showUserDropdownList = false;
 
  }
 
  logoutUser() {
    this.onboardingService.logoutUser().subscribe((res) => {
      this.trackUserLogout();
      this.zenDeskService.logoutUser();
      const check = localStorage.getItem('ptp-code')
      if(check === 'CREATICS-PTP'){
        localStorage.removeItem('ptp-code')
      }
      this.router.navigate(['home'])
    }, err => {
 
    })
  }
 
  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.showUserDropdownList = false;
    this.showDropdownListDiscover = false;
    this.showDropdownListAbout = false;
    this.showDropdownListEngage = false;
    this.showDropdownListCreate = false;
    this.showMobileDropDown = false;
  }
trackUserLogout(){
  this.mixPanelService.trackEvent({
        event:MixpanelEvent.LOGOUT,
        properties:{}
      })
}
}